export default "__VITE_ASSET__CPMTk6VN__"